const isGroupChatId = id => ['s-ct', 's-tt'].some(type => id.includes(type));

export default isGroupChatId;
